import React from 'react';

const SpinnerComponent = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen w-screen bg-white z-50">
      {/* Standard SVG Spinner Icon */}
      <svg
        className="w-16 h-16 text-blue-600 animate-spin"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>

      {/* Optional Text */}
      <p className="mt-4 text-gray-600 text-sm">Loading, please wait...</p>
    </div>
  );
};

export default SpinnerComponent;
